import { render, staticRenderFns } from "./businessParameters.vue?vue&type=template&id=0fa89398&scoped=true"
import script from "./businessParameters.vue?vue&type=script&lang=js"
export * from "./businessParameters.vue?vue&type=script&lang=js"
import style0 from "./businessParameters.vue?vue&type=style&index=0&id=0fa89398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa89398",
  null
  
)

export default component.exports